namespace GeniuzPOS.PriceChange {
    export enum PostFgStatus {
        UnPost = 0,
        Posted = 1
    }
    Serenity.Decorators.registerEnumType(PostFgStatus, 'GeniuzPOS.PriceChange.PostFgStatus');
}
